import ChatTripPlannerMobileBlocker from '../../ChatTripPlannerMobileBlocker'

function TripChatMobileSurface() {
  return <ChatTripPlannerMobileBlocker />
}

export default TripChatMobileSurface
